import comp from '../components/barrel';
import svg from '../js/svg';

// force commit

export default {
  async prepare() {
    // Assign target user_uuid to vars object for making requests specific to user
    this.target_user_uuid = thsPage.vars.target_user_uuid;
    const vars = {};
    vars.target_user_uuid = this.target_user_uuid;

    // Push request configuration objects to "methods" array
    this.recipe.methods.push(await O.mPOST('users/get-user-details', vars));
    this.recipe.methods.push(await O.mPOST('users/get-user-division-branch-list', vars));
    this.recipe.methods.push(await O.mPOST('users/get-support-advisor-list', vars));
    this.recipe.methods.push(await O.mPOST('users/get-advisor-list'));
    this.recipe.methods.push(await O.mPOST('communal/marketers'));
    this.recipe.methods.push(await O.mPOST('communal/divisions'));
    this.recipe.methods.push(await O.mPOST('communal/div-branches-by-div'));
    this.recipe.methods.push(await O.mPOST('communal/organisations'));
    this.recipe.methods.push(await O.mPOST('communal/org-branches'));
  },

  async render() {
    // Set plates as the array of request configuration objects assigned to the "methods" array
    const plates = this.recipe.methods;

    let data = {};
    if (plates.length) {
      data = await O.PREP(plates);
    }

    // Pass list request of responses to loadPage method
    await this.loadPage(data);
  },

  async loadPage(res) {
    this.advisorList = res['users/get-advisor-list'].data;
    this.marketersData = res['communal/marketers'].data.map((marketer) => ({...marketer, fullName: `${marketer.f_name} ${marketer.s_name}`}));

    // Add debugging for divisions data
    this.divisionsData = res['communal/divisions'].data.divisions;

    this.userDetails = res['users/get-user-details'].data;
    this.userSupportList = res['users/get-support-advisor-list'].data;

    // Add the missing userDivList - it should come from get-user-division-branch-list
    if (res['users/get-user-division-branch-list'] && res['users/get-user-division-branch-list'].data) {
      this.userDivList = res['users/get-user-division-branch-list'].data;
    } else {
      this.userDivList = [];
    }

    // Initialize divBranchesData as empty - will be loaded dynamically
    this.divBranchesData = [];

    const newUser = U.id('user-form');
    newUser.innerHTML = '';

    const grid1 = U.divAtt('div', 'class', 'res-grid-cols-1');
    const companyDiv = U.divAtt('div', 'id', 'companyDiv');
    const advisorDiv = U.divAtt('div', 'id', 'advisorDiv');
    const supportDiv = U.divAtt('div', 'id', 'supportDiv');
    const updateDiv = U.divAtt('div', 'id', 'updateDiv');

    grid1.appendChild(companyDiv);
    grid1.appendChild(advisorDiv);
    grid1.appendChild(supportDiv);
    grid1.appendChild(updateDiv);

    newUser.appendChild(grid1);
    await this.configForm();

    const allocTab = thsPage.tabs && thsPage.tabs['VUt_Allocations'];
    if (allocTab && allocTab.subMenu && allocTab.subMenu.length && U.id('subTabs')) {
      U.unhide('subTabs');
    }
    window.thsSubTab = thsTab;
  },

  async buildMainPage() {
    const newUser = U.id('user-form');
    newUser.innerHTML = '';

    const grid1 = U.divAtt('div', 'class', 'res-grid-cols-1');
    const companyDiv = U.divAtt('div', 'id', 'companyDiv');
    const advisorDiv = U.divAtt('div', 'id', 'advisorDiv');
    const supportDiv = U.divAtt('div', 'id', 'supportDiv');
    const updateDiv = U.divAtt('div', 'id', 'updateDiv');

    grid1.appendChild(companyDiv);
    grid1.appendChild(advisorDiv);
    grid1.appendChild(supportDiv);
    grid1.appendChild(updateDiv);

    newUser.appendChild(grid1);
  },

  async buildDivTable() {
    const userTable = U.id('tableList');
    // userTable.innerHTML = '';

    // if (!this.userDivList.length) {
    //   return;
    // }

    const tableHead = await U.id('tableHead');
    const tableBody = await U.id('tableBody');
    tableHead.innerHTML = '';
    tableBody.innerHTML = '';

    const headRow = tableHead.insertRow();

    const field1 = headRow.insertCell(0);
    field1.innerHTML = 'Division';

    const field2 = headRow.insertCell(1);
    field2.innerHTML = 'Division Branch';

    //ACTION
    headRow.insertCell(2);

    // Add null check for userDivList
    if (this.userDivList && this.userDivList.length) {
      this.userDivList.forEach(async (dataRow) => {
        const newRow = tableBody.insertRow();

        const row1 = newRow.insertCell(0);
        row1.innerHTML = dataRow.division_text;

        const row2 = newRow.insertCell(1);
        row2.innerHTML = dataRow.division_branch_text;

        const editButton = newRow.insertCell(2);
        const btnAction = `thsTab.removeDivision('${dataRow.user_division_branch_uuid}')`;
        const linkSVG = svg.trash(btnAction);
        editButton.appendChild(linkSVG);
      });
    } else {
      const newRow = tableBody.insertRow();
      const empty = newRow.insertCell(0);
      empty.innerHTML = 'No divisions allocated.';
      empty.colSpan = 2;
    }

    userTable.appendChild(tableHead);
    userTable.appendChild(tableBody);
    U.unhide('tableList');
  },

  async buildSupTable() {
    const userTable = U.id('tableList');
    // userTable.innerHTML = '';

    // if (!this.userDivList.length) {
    //   return;
    // }

    const tableHead = await U.id('tableHead');
    const tableBody = await U.id('tableBody');
    tableHead.innerHTML = '';
    tableBody.innerHTML = '';

    const headRow = tableHead.insertRow();

    const field1 = headRow.insertCell(0);
    field1.innerHTML = 'Advisor';

    //ACTION
    headRow.insertCell(1);

    if (this.userSupportList.length) {
      this.userSupportList.forEach(async (dataRow) => {
        const newRow = tableBody.insertRow();

        const row1 = newRow.insertCell(0);
        row1.innerHTML = `${dataRow.advisor_f_name} ${dataRow.advisor_s_name}`;

        const editButton = newRow.insertCell(1);
        const btnAction = `thsTab.removeSupport('${dataRow.advisor_support_uuid}')`;
        const linkSVG = svg.trash(btnAction);
        editButton.appendChild(linkSVG);
      });
    } else {
      const newRow = tableBody.insertRow();
      const empty = newRow.insertCell(0);
      empty.innerHTML = 'No advisors allocated.';
      empty.colSpan = 2;
    }

    userTable.appendChild(tableHead);
    userTable.appendChild(tableBody);
    U.unhide('tableList');
  },

  async configForm() {
    switch (this.userDetails.role_text) {
      case 'Marketer':
        await this.buildCompanySection();
        await this.buildDivTable();
        break;
      case 'Admin':
        await this.buildCompanySection();
        await this.buildDivTable();
        break;
      case 'Advisor':
        // Check if there's an org branch uuid assigned to user
        if (this.userDetails.org_branch_uuid) {
          // Renders all 4 hierarchy select dropdown options
          await this.buildOrgBranchSection();
        } else {
          // Renders dropdown input only for company selection
          await this.buildCompanySectionPlus();
        }
        U.id('updateProfileBtn').innerHTML = 'Update';
        break;
      case 'Support':
        await this.buildCompanySectionPlus();
        await this.buildSupTable();
        break;
      case 'Business development':
        await this.buildCompanySection();
        await this.buildDivTable();
        break;
      default:
        // Remove console.log('Placeholder page');
    }
  },

  async buildCompanySection() {
    const grid1 = U.id('companyDiv');
    grid1.innerHTML = '';
    // ================================================
    // COMPANY EMPLOYEE
    const companyHeading = U.divAtt('h6', 'class', 'mt-3');
    // companyHeading.innerHTML = 'Office Employee: ';
    grid1.appendChild(companyHeading);

    const gridOE = U.divAtt('div', 'class', 'res-grid-cols-2');
    const divBranch = U.divAtt('div', 'id', 'divBranch');
    const divisionDD = await comp.select_v2({elID: 'companyDD', ddData: this.divisionsData, valueDataName: 'division_uuid', textDataName: 'short_text', labelName: 'Company', requiredYN: 1, onchange: 'thsTab.showCompanyBranch()'});
    gridOE.appendChild(divisionDD);
    gridOE.appendChild(divBranch);
    grid1.appendChild(gridOE);
    
    // Attach event listener after element is in DOM
    setTimeout(() => {
      const companyDDSelect = U.id('companyDD');
      if (companyDDSelect) {
        companyDDSelect.removeAttribute('onchange');
        companyDDSelect.addEventListener('change', () => {
          if (window.thsTab && typeof window.thsTab.showCompanyBranch === 'function') {
            window.thsTab.showCompanyBranch();
          }
        });
      }
    }, 100);
    
    this.showCompanyBranch();
  },

  async showCompanyBranch() {
    const companyDD = U.id('companyDD');
    const companyDDValue = companyDD?.value;
    
    const grid1 = U.id('divBranch');
    grid1.innerHTML = '';
  
    if (!companyDDValue) {
      return;
    }

    try {
      const vars = {};
      vars.division_uuid = companyDDValue;
  
      const res = await O.PREP([await O.mPOST('communal/div-branches-by-div', vars)]);
      let divisionBranches = res['communal/div-branches-by-div'].data;

      if (divisionBranches && divisionBranches.length > 0) {
        // Remove duplicates based on division_branch_uuid
        const seen = new Set();
        divisionBranches = divisionBranches.filter(branch => {
          if (seen.has(branch.division_branch_uuid)) {
            return false;
          }
          seen.add(branch.division_branch_uuid);
          return true;
        });

        const compBranchDD = await comp.select_v2({
          elID: 'compBranchDD',
          ddData: divisionBranches,
          valueDataName: 'division_branch_uuid',
          textDataName: 'division_branch_text',
          labelName: 'Company Branch',
          requiredYN: 1
        });
        grid1.appendChild(compBranchDD);
      } else {
        grid1.innerHTML = '<p>No branches available for this company</p>';
      }
    } catch (error) {
      grid1.innerHTML = '<p>Error loading company branches</p>';
    }
  },

  // Showing all 4 hierarchy select inputs with their currently assigned values
  async buildOrgBranchSection() {
    // Reset container that shows all select inputs
    const grid1 = U.id('companyDiv');
    grid1.innerHTML = '';

    // Two rows: one for division & div-branch, other for org and org-branch
    const gridOE = U.divAtt('div', 'class', 'res-grid-cols-2');
    const gridOS = U.divAtt('div', 'class', 'res-grid-cols-2');
    gridOE.id = 'companySectionDiv';
    gridOS.id = 'organisationSectionDiv';
    grid1.appendChild(gridOE);
    grid1.appendChild(gridOS);

    // const filters = {};
    // filters.org_branch_uuid = this.userDetails.org_branch_uuid;

    // Reset to base vars object
    let vars = {};
    vars.org_branch_uuid = this.userDetails.org_branch_uuid;
    const companiesList = this.divisionsData;

    // Fetch list all hierarchy data based on the users org_branch_uuid
    O.PREP([await O.mPOST('communal/org-hierarchy-by-branch', vars)]).then(async (res) => {
      const hierarchyData = res['communal/org-hierarchy-by-branch'].data;

      let currentCompany = hierarchyData.division_uuid;
      let currentCompanyBranch = hierarchyData.division_branch_uuid;
      let currentOrganisation = hierarchyData.org_uuid;
      let currentOrganisationBranch = hierarchyData.org_branch_uuid;
      // Remove console.log('Hierarchy Deta', hierarchyData);

      // Initial dropdowns with currently assigned hierarchy values
      // ================================================
      // Company Select Input
      const companySelect = await comp.select_v2({elID: 'companyAllocation', ddData: companiesList, valueDataName: 'division_uuid', textDataName: 'short_text', labelName: 'Company', requiredYN: 1, onchange: 'thsTab.getCompanyBranches()', initValue: currentCompany});
      U.id('companySectionDiv').appendChild(companySelect);

      // Use event delegation to catch dropdown changes
      U.id('companySectionDiv').addEventListener('change', (e) => {
        if (e.target.id === 'companyAllocation') {
          if (window.thsTab && typeof window.thsTab.getCompanyBranches === 'function') {
            window.thsTab.getCompanyBranches();
          }
        }
      });

      // ================================================
      // Company Branch Select Input
      vars = {};
      vars.division_uuid = hierarchyData.division_uuid;

      O.PREP([await O.mPOST('communal/div-branches-by-div', vars)]).then(async (res) => {
        const companyBranchesList = res['communal/div-branches-by-div'].data;
        // Remove console.log('company branches', companyBranchesList);

        const companyBranchSelect = await comp.select_v2({elID: 'companyBranchAllocation', ddData: companyBranchesList, valueDataName: 'division_branch_uuid', textDataName: 'division_branch_text', labelName: 'Company Branch', requiredYN: 1, onchange: 'thsTab.getOrganisations()', initValue: currentCompanyBranch});
        U.id('companySectionDiv').appendChild(companyBranchSelect);
      });

      // ================================================
      // Organisation Select Input
      vars = {};
      vars.division_branch_uuid = hierarchyData.division_branch_uuid;

      O.PREP([await O.mPOST('communal/organisations', vars)]).then(async (res) => {
        const organisationsList = res['communal/organisations'].data; // Remove .organisations
        // Remove console.log('organisations', organisationsList);

        const organisationSelect = await comp.select_v2({elID: 'organisationAllocation', ddData: organisationsList, valueDataName: 'org_uuid', textDataName: 'short_text', labelName: 'Organisation', requiredYN: 1, onchange: 'thsTab.getOrganisationBranches()', initValue: currentOrganisation}); // Change org_text to short_text
        U.id('organisationSectionDiv').appendChild(organisationSelect);
      });

      // ================================================
      // Organisation Branch Select Input
      vars = {};
      vars.org_uuid = hierarchyData.org_uuid;

      O.PREP([await O.mPOST('communal/org-branches-by-org', vars)]).then(async (res) => {
        const companyBranches = res['communal/org-branches-by-org'].data;
        // Remove console.log('org branches', companyBranches);

        const organisationBranchSelect = await comp.select_v2({elID: 'organisationBranchAllocation', ddData: companyBranches, valueDataName: 'org_branch_uuid', textDataName: 'org_branch_text', labelName: 'Organisation Branch', requiredYN: 1, onchange: '', initValue: currentOrganisationBranch});
        U.id('organisationSectionDiv').appendChild(organisationBranchSelect);
      });
    });
  },

  async buildCompanySectionPlus() {
    //Remove any previous Dropdowns
    const companyBranchDiv = U.id('companyBranchAllocationDiv');
    const orgDiv = U.id('organisationAllocationDiv');
    const orgBranchDiv = U.id('organisationBranchAllocationDiv');

    if (companyBranchDiv) {
      await U.id('advisorsStep4Div').removeChild(companyBranchDiv);
    }
    if (orgDiv) {
      await U.id('advisorsStep4Div').removeChild(orgDiv);
    }
    if (orgBranchDiv) {
      await U.id('advisorsStep4Div').removeChild(orgBranchDiv);
    }

    const grid1 = U.id('companyDiv');
    grid1.innerHTML = '';

    // Two rows: one for division & div-branch, other for org and org-branch
    const gridOE = U.divAtt('div', 'class', 'res-grid-cols-2');
    const gridOS = U.divAtt('div', 'class', 'res-grid-cols-2');
    gridOE.id = 'companySectionDiv';
    gridOS.id = 'organisationSectionDiv';
    grid1.appendChild(gridOE);
    grid1.appendChild(gridOS);

    // Reset to base vars object
    const vars = {};
    // Fetch list of companies
    O.PREP([await O.mPOST('communal/divisions', vars)]).then(async (res) => {
      const companiesList = res['communal/divisions'].data.divisions;

      // Render Company Select Input
      let companySelect = await comp.select('companyAllocation', companiesList, 'division_uuid', 'short_text', 'Company', 1, 'thsTab.getCompanyBranches()');
      U.id('companySectionDiv').appendChild(companySelect);
    });
  },

  async getCompanyBranches() {
    // Get the company dropdown value
    const companySelect = U.id('companyAllocation');
    if (!companySelect || !companySelect.value) {
      return;
    }

    //Remove any previous Dropdowns
    const companyBranchDiv = U.id('companyBranchAllocationDiv');
    const orgDiv = U.id('organisationAllocationDiv');
    const orgBranchDiv = U.id('organisationBranchAllocationDiv');

    if (companyBranchDiv && U.id('companySectionDiv')) {
      try {
        U.id('companySectionDiv').removeChild(companyBranchDiv);
      } catch (e) {
      }
    }
    if (orgDiv && U.id('organisationSectionDiv')) {
      try {
        U.id('organisationSectionDiv').removeChild(orgDiv);
      } catch (e) {
      }
    }
    if (orgBranchDiv && U.id('organisationSectionDiv')) {
      try {
        U.id('organisationSectionDiv').removeChild(orgBranchDiv);
      } catch (e) {
      }
    }

    // Reset to base vars object
    const vars = {};
    vars.division_uuid = companySelect.value;

    // Fetch list of company branches
    try {
      const res = await O.PREP([await O.mPOST('communal/div-branches-by-div', vars)]);
      const companyBranchesList = res['communal/div-branches-by-div'].data;
      // Remove console.log('company Branches List', companyBranchesList);
      
      // Render Company Branch Select Input using select_v2 for consistency
      const companyBranchSelect = await comp.select_v2({
        elID: 'companyBranchAllocation',
        ddData: companyBranchesList,
        valueDataName: 'division_branch_uuid',
        textDataName: 'division_branch_text',
        labelName: 'Company Branch',
        requiredYN: 1,
        onchange: 'thsTab.getOrganisations()'
      });
      U.id('companySectionDiv').appendChild(companyBranchSelect);
    } catch (error) {
    }
  },

  async getOrganisations() {
    //Remove any previous Dropdowns
    const orgDiv = U.id('organisationAllocationDiv');
    const orgBranchDiv = U.id('organisationBranchAllocationDiv');

    if (orgDiv) {
      await U.id('organisationSectionDiv').removeChild(orgDiv);
    }
    if (orgBranchDiv) {
      await U.id('organisationSectionDiv').removeChild(orgBranchDiv);
    }

    // Reset to base vars object
    const vars = {};
    const companyBranchAllocationEl = U.id('companyBranchAllocation');
    if (!companyBranchAllocationEl || !companyBranchAllocationEl.value) {
      return;
    }
    vars.division_branch_uuid = companyBranchAllocationEl.value;

    // Fetch list of organisations
    O.PREP([await O.mPOST('communal/organisations', vars)]).then(async (res) => {
      const organisationsList = res['communal/organisations'].data;
      // Render Organisation Select Input
      let organisationSelect = await comp.select('organisationAllocation', organisationsList, 'org_uuid', 'short_text', 'Organisation', 1, 'thsTab.getOrganisationBranches()');
      U.id('organisationSectionDiv').appendChild(organisationSelect);
    });
  },

  async getOrganisationBranches() {
    //Remove any previous Dropdowns
    const orgBranchDiv = U.id('organisationBranchAllocationDiv');

    if (orgBranchDiv) {
      await U.id('organisationSectionDiv').removeChild(orgBranchDiv);
    }

    // Reset to base vars object
    const vars = {};
    const organisationAllocationEl = U.id('organisationAllocation');
    if (!organisationAllocationEl || !organisationAllocationEl.value) {
      return;
    }
    vars.org_uuid = organisationAllocationEl.value;

    // Fetch list of organisations
    O.PREP([await O.mPOST('communal/org-branches-by-org', vars)]).then(async (res) => {
      const organisationBranchesList = res['communal/org-branches-by-org'].data;
      // Render Organisation Branch Select Input
      let organisationBranchSelect = await comp.select('organisationBranchAllocation', organisationBranchesList, 'org_branch_uuid', 'org_branch_text', 'Organisation Branch', 1, '');
      U.id('organisationSectionDiv').appendChild(organisationBranchSelect);
    });
  },

  async buildSupportSection() {
    const grid1 = U.id('supportDiv');
    grid1.innerHTML = '';
    // const roleSelect = U.id('roleSelect');
    if (this.userDetails.role_text !== 'Support') {
      return;
    }

    const orgBranchDDEl = U.id('orgBranchDD');
    if (!orgBranchDDEl || !orgBranchDDEl.value) {
      return;
    }
    const orgBranchDD = orgBranchDDEl.value;
    // ================================================
    // ADVISOR
    const advisorHeading = U.divAtt('h6', 'class', 'mt-3');
    grid1.appendChild(advisorHeading);

    const gridA1 = U.divAtt('div', 'class', 'res-grid-cols-3');
    const filteredData = this.advisorList.filter((advisor) => advisor.org_branch_uuid === orgBranchDD);
    const advisorDD = await comp.select_v2({elID: 'advisorDD', ddData: filteredData, valueDataName: 'user_uuid', textDataName: 'c_name', labelName: 'Advisor', requiredYN: 1});

    gridA1.appendChild(advisorDD);
    grid1.appendChild(gridA1);
  },

  async allocate() {
    if (!(await U.validateForm('user-form'))) {
      return;
    }

    const role_text = this.userDetails.role_text;

    const vars = {};
    vars.role = this.userDetails.role_uuid;
    vars.role_text = this.userDetails.role_text;
    vars.target_user_uuid = this.target_user_uuid;

    switch (role_text) {
      case 'Marketer':
        vars.division_uuid = U.id('companyDD') ? U.id('companyDD').value : null;
        vars.division_branch_uuid = U.id('compBranchDD') ? U.id('compBranchDD').value : null;

        return await O.PREP([await O.mPOST('users/ins-user-division-branch', vars)])
          .then(async (res) => {
            const msg = res['users/ins-user-division-branch'].status;
            comp.toast(msg);
            this.render();
          })
          .catch(() => {});
        break;
      case 'Admin':
        vars.division_uuid = U.id('companyDD') ? U.id('companyDD').value : null;
        vars.division_branch_uuid = U.id('compBranchDD') ? U.id('compBranchDD').value : null;

        return await O.PREP([await O.mPOST('users/ins-user-division-branch', vars)])
          .then(async (res) => {
            const msg = res['users/ins-user-division-branch'].status;
            comp.toast(msg);
            this.render();
          })
          .catch(() => {});
        break;
      case 'Business development':
        vars.division_uuid = U.id('companyDD') ? U.id('companyDD').value : null;
        vars.division_branch_uuid = U.id('compBranchDD') ? U.id('compBranchDD').value : null;

        return await O.PREP([await O.mPOST('users/ins-user-division-branch', vars)])
          .then(async (res) => {
            const msg = res['users/ins-user-division-branch'].status;
            comp.toast(msg);
            this.render();
          })
          .catch(() => {});
        break;
      case 'Advisor':
        const organisationBranchAllocationEl = U.id('organisationBranchAllocation');
        if (!organisationBranchAllocationEl || !organisationBranchAllocationEl.value) {
          comp.toast('Please select an organisation branch');
          return;
        }
        vars.org_branch_uuid = organisationBranchAllocationEl.value;
        return await O.PREP([await O.mPOST('users/upd-advisor-org-branch', vars)])
          .then(async (res) => {
            const msg = res['users/upd-advisor-org-branch'].status;
            comp.toast(msg);
            this.render();
          })
          .catch(() => {});
        break;
      case 'Support':
        const advisorDDEl = U.id('advisorDD');
        if (!advisorDDEl || !advisorDDEl.value) {
          comp.toast('Please select an advisor');
          return;
        }
        vars.advisor_uuid = advisorDDEl.value;
        return await O.PREP([await O.mPOST('users/ins-support-advisor', vars)])
          .then(async (res) => {
            const msg = res['users/ins-support-advisor'].status;
            comp.toast(msg);
            this.render();
          })
          .catch(() => {});
        break;
    }

    return;
  },

  async removeDivision(user_division_branch_uuid) {
    if (!user_division_branch_uuid) {
      return;
    }

    const vars = {};
    vars.user_division_branch_uuid = user_division_branch_uuid;

    O.PREP([await O.mPOST('users/rmv-user-division-branch', vars)])
      .then(async (res) => {
        const msg = res['users/rmv-user-division-branch'].status;
        comp.toast(msg);
        this.render();
      })
      .catch(() => {});
  },

  async removeSupport(advisor_support_uuid) {
    if (!advisor_support_uuid) {
      return;
    }

    const vars = {};
    vars.advisor_support_uuid = advisor_support_uuid;

    O.PREP([await O.mPOST('users/rmv-support-advisor', vars)])
      .then(async (res) => {
        const msg = res['users/rmv-support-advisor'].status;
        comp.toast(msg);
        this.render();
      })
      .catch(() => {});
  },

  /** Submenu navigation under View User Allocation (thsSubTab used by side nav onclick). */
  async savePage(targetId) {
    if (typeof targetId === 'string' && /^VUt_/.test(targetId)) {
      await O.changeSubTab(targetId);
    }
  },
};
